import { Injectable } from "@angular/core";

@Injectable()
export class CronogramaService {
    // constructor(private http: HttpClient) { }
    // buscarPorParametro(param: string, pagina: Number, idprogramacao : number): Observable<any> {
    //   const headers = new HttpHeaders().set('noloader', 't');
    //   if (param.length > 0) {
    //     return this.http.get<any>(`${GERENCIAMENTO}/api/Cronograma/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}&IdProgramacao=${idprogramacao}`, { headers: headers });
    //   }
    //   else {
    //     return this.http.get<any>(`${GERENCIAMENTO}/api/Cronograma?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}&IdProgramacao=${idprogramacao}`, { headers: headers });
    //   }
    // }
    // buscarPorId(id: number): Observable<any> {
    //   return this.http.get<any>(`${GERENCIAMENTO}/api/Cronograma/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    // }
    // remover(id: Number): Observable<any> {
    //   return this.http.delete<any>(`${GERENCIAMENTO}/api/Cronograma/${id}`);
    // }
    // salvar(cronograma: Cronograma): Observable<any> {
    //   if (cronograma.Id > 0) {
    //     return this.http.put<any>(`${GERENCIAMENTO}/api/Cronograma/${cronograma.Id}`, cronograma);
    //   }
    //   else {
    //     return this.http.post<any>(`${GERENCIAMENTO}/api/Cronograma/`, cronograma);
    //   }
    // }
}
